import script from "./UiBadgeList.vue?vue&type=script&setup=true&lang=js"
export * from "./UiBadgeList.vue?vue&type=script&setup=true&lang=js"

import "./UiBadgeList.vue?vue&type=style&index=0&id=7c90f76b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c90f76b"]])

export default __exports__